/** Prefix that should be used for in the frontend generated ids */
export const LOCAL_ID_PREFIX = 'LOCAL_';
